
import { NgModule } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { AuthService } from './auth.service';
import { AuthGuardService } from './auth-guard.service';
import * as Cookie from 'js-cookie';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    tokenName: 'token',
    tokenGetter: (() => tokenGetter()),
    globalHeaders: [{ 'Content-Type': 'application/json' }],
  }), http, options);
}

export function tokenGetter(): string {
  const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  if (isIEOrEdge) {
   // alert(Cookie.get('token'));
    return Cookie.get('token');

  } else {
   // alert(localStorage.getItem('token'));
    return localStorage.getItem('token');
  }
}


@NgModule({
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    AuthService,
    AuthGuardService
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/services/auth/auth.module.ts